<div class="report-preview-layout" *ngIf="state$ | async as state" [ngSwitch]="state.status">

        <!-- STATUS LOADING -->
        <ng-container *ngSwitchCase="'LOADING'">
            <pv-spinner fill="white" message="Loading Report Preview..."></pv-spinner>
        </ng-container>

        <!-- STATUS OK -->
        <pv-advanced-reports
            *ngSwitchCase="'OK'"
            pv-view-body
            [preview]="true"
            [editMode]="false"
            [reportKey]="state.data.key"
            [ownerOrgKey]="state.data.ownerOrgKey"
            [shareKey]="state.data.shareKey">
        </pv-advanced-reports>

        <!-- STATUS ERROR -->
        <pv-view-message *ngSwitchCase="'NOT_FOUND'"
                         heading="Report Not Found"
                         message="Contact the owner of the report to ensure you have the updated link."
                         icon="error">
        </pv-view-message>

        <!-- STATUS ERROR -->
        <pv-view-message *ngSwitchDefault
                         heading="{{ state.status | descStatusTitle }}"
                         message="{{ state.status | descStatusMessage: 'Report Preview' }}"
                         icon="error">
            <button pvMessageAction mat-raised-button color="accent"
                    (click)="refresh()">Refresh</button>
        </pv-view-message>

</div>
